import { Children, ReactNode } from 'react'
import { Box, BoxProps, Flex, useAppTheme } from '@workwhile/ui'
import { LucideIcon } from 'lucide-react'

type ShiftDetailBodySectionProps = BoxProps & {
  Icon: LucideIcon
  children: ReactNode
  iconColor?: string
}

export const ShiftDetailBodySection = ({
  Icon,
  children,
  iconColor,
  ...rest
}: ShiftDetailBodySectionProps) => {
  const { colors, space } = useAppTheme()
  const isSingleLine = Children.count(children) === 1
  return (
    <Flex
      flexDirection="row"
      alignItems={isSingleLine ? 'center' : 'flex-start'}
      style={{ gap: space[2] }}
      {...rest}
    >
      <Icon
        size={16}
        color={iconColor || colors.neutrals[300]}
        style={isSingleLine ? { marginTop: 0 } : { marginTop: space[1] }}
      />
      {isSingleLine ? children : <Box>{children}</Box>}
    </Flex>
  )
}
